/* eslint-disable */
import dayjs from 'dayjs';
import { MONITOREOS_INTERNET, MONITOREOS_VISITAS_VERIFICACION } from 'constants/tipoMonitoreos';
import { MONITOREO_TERMINADO } from 'constants/estatusMonitoreo';
import { TIPO_ACCESO_WEB } from 'constants/tiposAcceso';
import { FORMAT_BACKEND } from 'constants/dateFormat';
import { DATE_STRING_TO_MOMENT } from 'utils/date';
import {
  TIPO_FIRMANTES_COMPARECIENTE,
  TIPO_FIRMANTES_SERV_EVENTO,
  TIPO_FIRMANTES_TESTIGOS,
  TIPO_FIRMANTES_VERIFICADOR
} from 'constants/signerFiles';

const findElementNomBene = (array, searchElement) => {
  if (array?.length !== undefined) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < array.length; i++) {
      const element = array[i];
      if (element.nombreBeneficiado === undefined) return null;
      if (element.nombreBeneficiado === searchElement) {
        return i;
      }
    }
  }
  return -1;
};

const eliminarObjetosDuplicadosPorPropiedad = (
  arr,
  propiedad1,
  propiedad2,
  propiedad3,
  propiedad4
) => {
  const objetoTemporal = {};
  return arr.filter((objeto) => {
    const clave = objeto[propiedad1] + objeto[propiedad2] + objeto[propiedad3] + objeto[propiedad4];
    if (!objetoTemporal[clave]) {
      objetoTemporal[clave] = true;
      return true;
    }
    return false;
  });
};

const getBase64Image = (archivo) => {
  try {
    if (!archivo || !archivo.fileList || archivo.fileList.length === 0) {
      return undefined;
    }

    const fileObject = archivo.fileList[0]?.originFileObj;

    if (!fileObject) {
      return undefined;
    }

    if (archivo.fileList[0]?.url) {
      return null;
    }

    return fileObject.fullBase64Img ? fileObject.fullBase64Img.split(',')[1] : undefined;
  } catch (error) {
    console.log('Error: ', error);
  }
};

const newFormatBeneficiados = (
  beneficiados,
  catalogoBeneficiados,
  idProcesoEspecifico,
  beneficiadosOriginales
) => {
  // console.log('catalogoBen', catalogoBeneficiados);
  // console.log('Beneficiados', beneficiados, idProcesoEspecifico, beneficiadosOriginales);

  let beneficiadoTemp;
  const beneficiadosFormateados = beneficiados?.map((beneficiado, index) => {
    if (beneficiado.beneficiado > 0) {
      beneficiadoTemp =
        catalogoBeneficiados?.find((b) => b.idContabilidad === beneficiado.beneficiado) || {};
      const beneficiadoFormateado = {
        ...beneficiadoTemp,
        pkBeneficiado: index + 1
      };
      return beneficiadoFormateado;
    }

    if (beneficiado.beneficiado === undefined && beneficiado.idSujetoObligado !== 0) {
      // console.log('proceso especifico', idProcesoEspecifico);
      const beneficiadosTemporales =
        catalogoBeneficiados?.filter(
          (b) =>
            // b.idProcesoSIMAC === idProcesoEspecifico &&
            b.idSujetoObligado === beneficiado.idSujetoObligado &&
            b.idTipoAsociacion === beneficiado.idTipoAsociacion &&
            b.tipoAsociacion === beneficiado.tipoAsociacion
        ) || [];

      beneficiadoTemp = beneficiado.cargo
        ? beneficiadosTemporales?.find((b) => b.cargo === beneficiado.cargo)
        : beneficiadosTemporales[0] || {};

      if (beneficiadoTemp === undefined) {
        const beneficiadoFormateado = {
          ...beneficiadosTemporales[0],
          cargo: beneficiado.cargo,
          pkBeneficiado: index + 1
        };
        return beneficiadoFormateado;
      }
      const beneficiadoFormateado = {
        ...beneficiadoTemp,
        pkBeneficiado: index + 1
      };
      return beneficiadoFormateado;
    }

    if (beneficiado.beneficiado === undefined && beneficiado.idSujetoObligado === 0) {
      const beneficiadosTemporales =
        catalogoBeneficiados?.filter(
          (b) =>
            // b.idProcesoSIMAC === idProcesoEspecifico &&
            b.idTipoAsociacion === beneficiado.idTipoAsociacion &&
            b.tipoAsociacion === beneficiado.tipoAsociacion
        ) || [];

      beneficiadoTemp = beneficiado.cargo
        ? beneficiadosTemporales?.find((b) => b.cargo === beneficiado.cargo)
        : beneficiadosTemporales[0] || {};

      if (beneficiadoTemp === undefined) {
        const beneficiadoFormateado = {
          ...beneficiadosTemporales[0],
          cargo: beneficiado.cargo,
          idSujetoObligado: beneficiado.idSujetoObligado,
          sujetoObligado: beneficiado.sujetoObligado,
          pkBeneficiado: index + 1
        };
        return beneficiadoFormateado;
      }
      const beneficiadoFormateado = {
        ...beneficiadoTemp,
        idSujetoObligado: beneficiado.idSujetoObligado,
        sujetoObligado: beneficiado.sujetoObligado,
        pkBeneficiado: index + 1
      };
      return beneficiadoFormateado;
    }

    const beneficiadoFormateado = {
      ...beneficiado,
      pkBeneficiado: index + 1 // Dato arbitrario solicitado por el backend
    };
    return beneficiadoFormateado;
  });

  let beneficiadosFormateadosSinDuplicidad;

  if (beneficiados?.length !== 0 && beneficiados[0].beneficiado === undefined) {
    beneficiadosFormateadosSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
      beneficiadosFormateados,
      'nombreBeneficiado',
      'idTipoAsociacion',
      'idContabilidad'
    );
  }

  beneficiadosFormateadosSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
    beneficiadosFormateados,
    'nombreBeneficiado',
    'idTipoAsociacion',
    'idSujetoObligado',
    'cargo'
  );

  beneficiadosOriginales?.map((beneficiadoOriginal) => {
    let updatedBeneficiado = {};

    const index = findElementNomBene(
      beneficiadosFormateadosSinDuplicidad,
      beneficiadoOriginal.nombreBeneficiado
    );

    // console.log('index duplicidad beneficiados', index);
    if (index !== -1 && index !== null) {
      updatedBeneficiado = {
        ...beneficiadosFormateadosSinDuplicidad[index],
        idBeneficiado: beneficiadoOriginal.idBeneficiado
      };
      beneficiadosFormateadosSinDuplicidad[index] = updatedBeneficiado;
      return updatedBeneficiado;
    }

    updatedBeneficiado = {
      ...beneficiadoOriginal,
      estatus: 0
    };

    beneficiadosFormateadosSinDuplicidad.push(updatedBeneficiado);
    return updatedBeneficiado;
  });
  return beneficiadosFormateadosSinDuplicidad;
};

const formatFirmantes = (firmantes, firmantesCatalogo, beneficiadosOriginales) => {
  return firmantes?.map((firmante, index) => {
    const firmanteSeleccionado = firmantesCatalogo.find((f) => f.idUsuario === firmante.firmante);
    return {
      ...beneficiadosOriginales?.[index],
      pkFirmante: index + 1, // Dato arbitrario solicitado por el backend
      idUsuario: firmante.firmante,
      firma: getBase64Image(firmante.firma),
      idTipoFirmante: 1,
      nombre: firmanteSeleccionado.nombre,
      apPaterno: firmanteSeleccionado.apPaterno,
      apMaterno: firmanteSeleccionado.apMaterno,
      puesto: firmanteSeleccionado.puesto,
      numEmpleado: firmanteSeleccionado.numEmpleado
    };
  });
};

const formatFirmantesImagenes = (firmantes, tipoFirmante) => {
  return firmantes?.map((firmante, index) => {
    const { idAnverso, idReverso, firma, fechaInicioComision, fechaFinComision, ...rest } =
      firmante;
    return {
      ...rest,
      fechaInicioComision: fechaInicioComision?.format(FORMAT_BACKEND),
      fechaFinComision: fechaFinComision?.format(FORMAT_BACKEND),
      idTipoFirmante: tipoFirmante,
      idUsuario: firmante.catVerificador,
      pkFirmante: index + 1,
      identAnverso: idAnverso.fileList[0]?.url ? null : getBase64Image(idAnverso),
      identReverso: idReverso.fileList[0]?.url ? null : getBase64Image(idReverso),
      firma: firma?.fileList?.[0]?.url ? null : getBase64Image(firma)
    };
  });
};

const formatServidoresEventos = (firmantes, initialServidores) => {
  return firmantes?.map((firmante, index) => {
    // eslint-disable-next-line camelcase
    const { muestra_1, muestra_2, muestra_3, muestra_4, muestra_5, ...firmanteRest } = firmante;
    return {
      ...firmanteRest,
      idTipoFirmante: TIPO_FIRMANTES_SERV_EVENTO,
      pkFirmante: index + 1,
      firma: getBase64Image(firmante.firma),
      evidencias: [
        {
          ...initialServidores?.[index]?.evidencias?.[0],
          pkEvidencia: 1,
          evidencia: getBase64Image(muestra_1)
        },
        {
          ...initialServidores?.[index]?.evidencias?.[1],
          pkEvidencia: 2,
          evidencia: getBase64Image(muestra_2)
        },
        {
          ...initialServidores?.[index]?.evidencias?.[2],
          pkEvidencia: 3,
          evidencia: getBase64Image(muestra_3)
        },
        {
          ...initialServidores?.[index]?.evidencias?.[3],
          pkEvidencia: 4,
          evidencia: getBase64Image(muestra_4)
        },
        {
          ...initialServidores?.[index]?.evidencias?.[4],
          pkEvidencia: 5,
          evidencia: getBase64Image(muestra_5)
        }
      ].filter((m) => m.evidencia)
    };
  });
};

const formatHallazgos = (
  hallazgos,
  tiposHallazgoCatalogo,
  idProcesoEspecifico,
  tipoBeneficio,
  idDistritoLoc,
  idDistritoFed,
  idMunicipio,
  initialHallazgos,
  estatus,
  motivoCancelacion,
  idMonitoreo,
  idAmbito
) => {
  const hallazgosFormateados = hallazgos?.map((hallazgo, index) => ({
    ...initialHallazgos?.[index],
    pkHallazgo: index + 1, // Dato arbitrario solicitado por el backend
    idProcesoEspecifico,
    tipoRegistro: TIPO_ACCESO_WEB,
    estatus,
    motivoCancelacion,
    fechaCreacion: dayjs().format(FORMAT_BACKEND),
    idTipoHallazgo: hallazgo.tipoHallazgo,
    tipoHallazgo: tiposHallazgoCatalogo.find((p) => p.idHallazgo === hallazgo.tipoHallazgo)
      ?.nombreHallazgo,
    otroTipoHallazgo: '',
    tipoBeneficio,
    idDistritoFed: idDistritoFed || 0,
    idDistritoLoc,
    idMunicipio,
    idMonitoreo,
    idAmbito,
    idINE: hallazgo.idINE,
    cantidad: hallazgo.cantidad,
    subTipoHallazgo: hallazgo.subTipoHallazgo,
    lema: hallazgo.lema,
    idTipoMedida: hallazgo.idTipoMedida,
    tipoMedida: hallazgo.tipoMedida,
    medida: hallazgo.medida,
    color: hallazgo.color,
    tamanio: hallazgo.tamanio,
    placas: hallazgo.placas,
    duracionHr: hallazgo.duracionHr,
    duracionMin: hallazgo.duracionMin,
    duracionSeg: hallazgo.duracionSeg,
    infAdicional: hallazgo.infAdicional,
    muestras: [
      {
        ...initialHallazgos?.[index]?.muestras?.[0],
        pkMuestra: 1,
        muestra: getBase64Image(hallazgo.muestra_1)
      },
      {
        ...initialHallazgos?.[index]?.muestras?.[1],
        pkMuestra: 2,
        muestra: getBase64Image(hallazgo.muestra_2)
      },
      {
        ...initialHallazgos?.[index]?.muestras?.[2],
        pkMuestra: 3,
        muestra: getBase64Image(hallazgo.muestra_3)
      },
      {
        ...initialHallazgos?.[index]?.muestras?.[3],
        pkMuestra: 4,
        muestra: getBase64Image(hallazgo.muestra_4)
      },
      {
        ...initialHallazgos?.[index]?.muestras?.[4],
        pkMuestra: 5,
        muestra: getBase64Image(hallazgo.muestra_5)
      }
    ].filter((m) => m.muestra) // Quitamos los elementos que no tengan imagen
  }));
  // console.log('hallazgosFormateados', hallazgosFormateados);
  return hallazgosFormateados;
};

const formatDocumentaciones = (documentos, initialServidores) => {
  return documentos?.map((documento, index) => {
    // eslint-disable-next-line camelcase
    const { muestra_1, muestra_2, muestra_3, muestra_4, muestra_5, ...rest } = documento;
    return {
      ...rest,
      pkDocumentacion: documento?.idDocumentacion,
      tipoDocumento: documento?.tipoDocumento,
      cantidad: documento?.cantidad,
      observaciones: documento?.observaciones,
      firma: getBase64Image(documento?.firma),
      evidencias: [
        {
          ...initialServidores?.[index]?.evidencias?.[0],
          pkEvidencia: 1,
          evidencia: getBase64Image(muestra_1)
        },
        {
          ...initialServidores?.[index]?.evidencias?.[1],
          pkEvidencia: 2,
          evidencia: getBase64Image(muestra_2)
        },
        {
          ...initialServidores?.[index]?.evidencias?.[2],
          pkEvidencia: 3,
          evidencia: getBase64Image(muestra_3)
        },
        {
          ...initialServidores?.[index]?.evidencias?.[3],
          pkEvidencia: 4,
          evidencia: getBase64Image(muestra_4)
        },
        {
          ...initialServidores?.[index]?.evidencias?.[4],
          pkEvidencia: 5,
          evidencia: getBase64Image(muestra_5)
        }
      ].filter((m) => m.evidencia)
    };
  });
};

export const formatoCreacionMonitoreoInternet = (dataFormulario, catalogos) => {
  // Esta estructura es solicitada por backend
  const payloadBase = {
    monitoreos: {
      toTerminate: [],
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toSave: []
    },
    actasInicio: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    },
    hallazgos: {
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toUpdate: [],
      toSave: []
    },
    actasCierre: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    }
  };

  const nuevoMonitoreo = {
    pkMonitoreo: 1, // Este valor se queda fijo puede ser lo que sea
    idTipoMonitoreo: MONITOREOS_INTERNET,
    estatusMonitoreo: MONITOREO_TERMINADO.value,
    idProcesoGral: dataFormulario?.idProcesoGral,
    descripcionProcesoGral:
      catalogos.data.procesosElectorales?.find(
        (p) => p.idProcesoElectoral === dataFormulario?.idProcesoGral
      )?.descripcion || '',
    // descripcionProcesoGral: '', // TODO: ver si es necesario para la edicion
    idTipoEleccion: 2, // No se establece desde el formulario
    idAmbito: dataFormulario?.idAmbito,
    idEstado: dataFormulario?.idEstado,
    tipoRegistro: TIPO_ACCESO_WEB,
    // idUsuario: 75, // TODO: ver si es necesario
    fechaRegistro: dayjs().format(FORMAT_BACKEND), // Momento de la generacion
    notificarPartido: 0, // No se establece desde el formulario
    formatos: [
      {
        pkFormato: 1, // Dato arbitrario solicitado por el payload
        fechaBusqueda: dataFormulario?.fecha_busqueda?.format(FORMAT_BACKEND),
        acuerdoCOF: dataFormulario?.acuerdo_cof,
        idPlataforma: dataFormulario?.plataforma_digital,
        fechaAcuerdoAprobado: dataFormulario?.fecha_acuerdo_aprobado?.format(FORMAT_BACKEND),
        otraPlataforma: '', // TODO: falta hacer logica para obtener esta parte
        url: dataFormulario?.URL,
        beneficiados: newFormatBeneficiados(
          dataFormulario?.beneficiados,
          catalogos.data.beneficiados,
          dataFormulario?.idProcesoEspecifico
        ),
        firmantes: formatFirmantes(dataFormulario?.firmas, catalogos.data.usuariosFiscalizacion)
      }
    ],
    hallazgos: formatHallazgos(
      dataFormulario?.hallazgos,
      catalogos.data.tipoMonitoreos.find(
        (m) => m.idTipoMonitoreo === MONITOREOS_VISITAS_VERIFICACION
      )?.tipoHallazgos,
      dataFormulario?.idProcesoEspecifico,
      dataFormulario?.tipo_beneficio,
      dataFormulario?.idDistritoLoc,
      dataFormulario?.idDistritoFed,
      dataFormulario?.idMunicipio
    )
  };

  payloadBase.monitoreos.toSave.push(nuevoMonitoreo);
  return payloadBase;
};

export const formatoEdicionMonitoreoEventos = (
  dataFormulario,
  catalogos,
  initialData,
  catalogoBeneficiados
) => {
  // console.log('CatBeneficiados:::', catalogoBeneficiados);
  const payloadBase = {
    monitoreos: {
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toUpdate: [],
      toSave: []
    },
    hallazgos: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    },
    visitas: {
      toUpdate: []
    }
  };

  const initialVisitas = initialData?.tableRow?.visitas?.[0] || {};
  const initialHallazgos = initialData?.tableRow?.hallazgos || [];

  // console.log('initialVisitas', initialVisitas);

  const visitas = [
    {
      pkVisita: 1,
      idVisita: initialVisitas.idVisita,
      idMonitoreo: initialVisitas.idMonitoreo,
      idEstado:
        initialData?.tableRow?.idEstado !== dataFormulario?.idEstado
          ? dataFormulario?.idEstado
          : null,
      idEventoSIF: dataFormulario?.idEventoSIF,
      acuerdoCOF: dataFormulario?.acuerdoCOF,
      fechaAcuerdoAprobado: dataFormulario?.fechaAcuerdoAprobado?.format(FORMAT_BACKEND),
      ordenVisita: dataFormulario?.ordenVisita,
      fechaApertura: dataFormulario?.fechaApertura?.format(FORMAT_BACKEND),
      fechaCierre: dataFormulario?.fechaCierre?.format(FORMAT_BACKEND),
      manifestacion: dataFormulario?.manifestacion,
      otrosHechos: dataFormulario?.otrosHechos,
      // duracionHr: dataFormulario?.duracionHr,
      // duracionMin: dataFormulario?.duracionMin,
      // duracionSeg: dataFormulario?.duracionSeg,
      identificadorEvento: dataFormulario?.identificadorEvento,
      infAdicional: dataFormulario?.infAdicional,
      idTipoAsociacion: dataFormulario?.idTipoAsociacion,
      idSujetoObligado: dataFormulario?.idSujetoObligado,
      numeroEscrito: dataFormulario?.numeroEscrito,
      fechaEscrito: dataFormulario?.fechaEscrito?.format(FORMAT_BACKEND),
      nombreFirmante: dataFormulario?.nombreFirmante,
      puesto: dataFormulario?.puesto,
      ubicacion: {
        idUbicacion: initialVisitas.ubicacion?.idUbicacion,
        pkUbicacion: initialVisitas.ubicacion?.idUbicacion,
        idMunicipio: dataFormulario?.idMunicipio,
        calle: dataFormulario?.calle,
        numero: dataFormulario?.numero,
        colonia: dataFormulario?.colonia,
        codigoPostal: dataFormulario?.codigoPostal,
        entreCalle1: dataFormulario?.entreCalle1,
        entreCalle2: dataFormulario?.entreCalle2,
        referencias: dataFormulario?.referencias,
        longitud: dataFormulario?.longitud,
        latitud: dataFormulario?.latitud
      },
      beneficiados: newFormatBeneficiados(
        dataFormulario?.beneficiados,
        catalogoBeneficiados,
        dataFormulario?.idProcesoEspecifico,
        initialVisitas.beneficiados
      ),
      comparecientes: formatFirmantesImagenes(
        dataFormulario?.comparecientes,
        TIPO_FIRMANTES_COMPARECIENTE
      ),
      documentaciones: formatDocumentaciones(
        dataFormulario?.documentaciones,
        initialVisitas.documentaciones
      ),
      verificadores: formatFirmantesImagenes(
        dataFormulario?.verificadores,
        TIPO_FIRMANTES_VERIFICADOR
      ),
      testigos: formatFirmantesImagenes(dataFormulario?.testigos, TIPO_FIRMANTES_TESTIGOS),
      servidoresEvento: formatServidoresEventos(
        dataFormulario?.servidores,
        initialVisitas.servidoresEvento
      )
    }
  ];

  const hallazgos = formatHallazgos(
    dataFormulario?.hallazgos,
    catalogos.data.tipoMonitoreos.find((m) => m.idTipoMonitoreo === MONITOREOS_VISITAS_VERIFICACION)
      ?.tipoHallazgos,
    dataFormulario?.idProcesoEspecifico,
    dataFormulario?.tipo_beneficio,
    dataFormulario?.idDistritoLoc,
    dataFormulario?.idDistritoFed,
    dataFormulario?.idMunicipio,
    initialHallazgos,
    dataFormulario?.estatus,
    dataFormulario?.motivoCancelacion,
    initialHallazgos[0]?.idMonitoreo,
    dataFormulario?.idAmbito
  );

  // Se verifica si se eliminaron o actualizaron las muestras
  for (let i = 0; i < initialHallazgos.length; i += 1) {
    const hallazgosForm = dataFormulario?.hallazgos[i];
    // Si hallazgos[i] = undefined, quiere decir que se eliminó un hallazgo
    if (dataFormulario?.hallazgos[i] !== undefined) {
      // en caso de validar el monitoreo, se verifica si el hallazgo estaba cancelado
      // se verifican cambios en la muestra 1
      if (hallazgosForm.muestra_1?.file && initialHallazgos[i].muestras[0] !== undefined) {
        initialHallazgos[i].muestras[0].estatus = 0;
        hallazgos[i].muestras.push(initialHallazgos[i].muestras[0]);
        if (hallazgosForm.muestra_1?.file?.status !== 'removed') {
          const newMuestra = {
            pkMuestra: 1,
            muestra: hallazgosForm.muestra_1.fileList[0].originFileObj.fullBase64Img.split(',')[1]
          };
          hallazgos[i].muestras.push(newMuestra);
        }
      }
      // se verifican cambios en la muestra 2
      if (hallazgosForm.muestra_2?.file && initialHallazgos[i].muestras[1] !== undefined) {
        initialHallazgos[i].muestras[1].estatus = 0;
        hallazgos[i].muestras.push(initialHallazgos[i].muestras[1]);
        if (hallazgosForm.muestra_2?.file?.status !== 'removed') {
          const newMuestra = {
            pkMuestra: 2,
            muestra: hallazgosForm.muestra_2.fileList[0].originFileObj.fullBase64Img.split(',')[1]
          };
          hallazgos[i].muestras.push(newMuestra);
        }
      }
      // se verifican cambios en la muestra 3
      if (hallazgosForm.muestra_3?.file && initialHallazgos[i].muestras[2] !== undefined) {
        initialHallazgos[i].muestras[2].estatus = 0;
        hallazgos[i].muestras.push(initialHallazgos[i].muestras[2]);
        if (hallazgosForm.muestra_3?.file?.status !== 'removed') {
          const newMuestra = {
            pkMuestra: 3,
            muestra: hallazgosForm.muestra_3.fileList[0].originFileObj.fullBase64Img.split(',')[1]
          };
          hallazgos[i].muestras.push(newMuestra);
        }
      }
      // se verifican cambios en la muestra 4
      if (hallazgosForm.muestra_4?.file && initialHallazgos[i].muestras[3] !== undefined) {
        initialHallazgos[i].muestras[3].estatus = 0;
        hallazgos[i].muestras.push(initialHallazgos[i].muestras[3]);
        if (hallazgosForm.muestra_4?.file?.status !== 'removed') {
          const newMuestra = {
            pkMuestra: 4,
            muestra: hallazgosForm.muestra_4.fileList[0].originFileObj.fullBase64Img.split(',')[1]
          };
          hallazgos[i].muestras.push(newMuestra);
        }
      }
      // se verifican cambios en la muestra 5
      if (hallazgosForm.muestra_5?.file && initialHallazgos[i].muestras[4] !== undefined) {
        initialHallazgos[i].muestras[4].estatus = 0;
        hallazgos[i].muestras.push(initialHallazgos[i].muestras[4]);
        if (hallazgosForm.muestra_5?.file?.status !== 'removed') {
          const newMuestra = {
            pkMuestra: 5,
            muestra: hallazgosForm.muestra_5.fileList[0].originFileObj.fullBase64Img.split(',')[1]
          };
          hallazgos[i].muestras.push(newMuestra);
        }
      }
    } else {
      initialHallazgos[i].estatus = 3;
      initialHallazgos[i].pkHallazgo = i + 1;
      initialHallazgos[i].eliminado = 1;
      hallazgos.push(initialHallazgos[i]);
    }
  }
  // Se verifica si se eliminaron o actualizaron las evidencias de la documentación recibida
  const documentosEliminados = [];
  for (let i = 0; i < initialVisitas.documentaciones.length; i += 1) {
    const docsForm = dataFormulario?.documentaciones[i];
    if (docsForm !== undefined) {
      if (
        initialVisitas.documentaciones[i].evidencias !== undefined &&
        initialVisitas.documentaciones[i].evidencias?.length > 0
      ) {
        // se verifican cambios en la evidencia 1
        if (
          docsForm.muestra_1?.file &&
          initialVisitas.documentaciones[i].evidencias[0] !== undefined
        ) {
          initialVisitas.documentaciones[i].evidencias[0].estatus = 0;
          visitas[0].documentaciones[i].evidencias.push(
            initialVisitas.documentaciones[i].evidencias[0]
          );
          if (docsForm.muestra_1?.file?.status !== 'removed') {
            const newEvidencia = {
              pkEvidencia: 1,
              evidencia: docsForm.muestra_1.fileList[0].originFileObj.fullBase64Img.split(',')[1]
            };
            visitas[0].documentaciones[i].evidencias.push(newEvidencia);
          }
        }
        // se verifican cambios en la evidencia 2
        if (
          docsForm.muestra_2?.file &&
          initialVisitas.documentaciones[i].evidencias[1] !== undefined
        ) {
          initialVisitas.documentaciones[i].evidencias[1].estatus = 0;
          visitas[0].documentaciones[i].evidencias.push(
            initialVisitas.documentaciones[i].evidencias[1]
          );
          if (docsForm.muestra_2?.file?.status !== 'removed') {
            const newEvidencia = {
              pkEvidencia: 2,
              evidencia: docsForm.muestra_2.fileList[0].originFileObj.fullBase64Img.split(',')[1]
            };
            visitas[0].documentaciones[i].evidencias.push(newEvidencia);
          }
        }
        // se verifican cambios en la evidencia 3
        if (
          docsForm.muestra_3?.file &&
          initialVisitas.documentaciones[i].evidencias[2] !== undefined
        ) {
          initialVisitas.documentaciones[i].evidencias[2].estatus = 0;
          visitas[0].documentaciones[i].evidencias.push(
            initialVisitas.documentaciones[i].evidencias[2]
          );
          if (docsForm.muestra_3?.file?.status !== 'removed') {
            const newEvidencia = {
              pkEvidencia: 3,
              evidencia: docsForm.muestra_3.fileList[0].originFileObj.fullBase64Img.split(',')[1]
            };
            visitas[0].documentaciones[i].evidencias.push(newEvidencia);
          }
        }
        // se verifican cambios en la evidencia 4
        if (
          docsForm.muestra_4?.file &&
          initialVisitas.documentaciones[i].evidencias[3] !== undefined
        ) {
          initialVisitas.documentaciones[i].evidencias[3].estatus = 0;
          visitas[0].documentaciones[i].evidencias.push(
            initialVisitas.documentaciones[i].evidencias[3]
          );
          if (docsForm.muestra_4?.file?.status !== 'removed') {
            const newEvidencia = {
              pkEvidencia: 4,
              evidencia: docsForm.muestra_4.fileList[0].originFileObj.fullBase64Img.split(',')[1]
            };
            visitas[0].documentaciones[i].evidencias.push(newEvidencia);
          }
        }
        // se verifican cambios en la evidencia 5
        if (
          docsForm.muestra_5?.file &&
          initialVisitas.documentaciones[i].evidencias[4] !== undefined
        ) {
          initialVisitas.documentaciones[i].evidencias[4].estatus = 0;
          visitas[0].documentaciones[i].evidencias.push(
            initialVisitas.documentaciones[i].evidencias[4]
          );
          if (docsForm.muestra_5?.file?.status !== 'removed') {
            const newEvidencia = {
              pkEvidencia: 5,
              evidencia: docsForm.muestra_5.fileList[0].originFileObj.fullBase64Img.split(',')[1]
            };
            visitas[0].documentaciones[i].evidencias.push(newEvidencia);
          }
        }
      }
    } else {
      initialVisitas.documentaciones[i].estatus = 0;
      initialVisitas.documentaciones[i].evidencias.forEach((evidencia) => {
        // eslint-disable-next-line no-unused-vars
        const { evidencia: evidenciaValue } = evidencia;
        // eslint-disable-next-line no-param-reassign
        evidencia.estatus = 0;
        // eslint-disable-next-line no-param-reassign
        evidencia.url = '';
      });
      documentosEliminados.push(initialVisitas.documentaciones[i]);
      // console.log('documentosEliminados', documentosEliminados);
    }
    if (documentosEliminados.length > 0) {
      documentosEliminados.forEach((doc) => {
        const updatedDoc = { ...doc, estatus: 0 };
        visitas[0].documentaciones.push(updatedDoc);
      });
    }
  }
  // Se verifica si se eliminaron o actualizaron las evidencias del servidor público
  for (let i = 0; i < initialVisitas.servidoresEvento.length; i += 1) {
    const evidenciaServ = dataFormulario?.servidores[i];
    if (evidenciaServ !== undefined) {
      // se verifican cambios en la evidencia 1
      if (
        initialVisitas.servidoresEvento[i].evidencias !== undefined &&
        initialVisitas.servidoresEvento[i].evidencias?.length > 0
      ) {
        if (
          evidenciaServ.muestra_1?.file &&
          initialVisitas.servidoresEvento[i].evidencias[0] !== undefined
        ) {
          initialVisitas.servidoresEvento[i].evidencias[0].estatus = 0;
          visitas[0].servidoresEvento[i].evidencias.push(
            initialVisitas.servidoresEvento[i].evidencias[0]
          );
          if (evidenciaServ.muestra_1?.file?.status !== 'removed') {
            const newEvidencia = {
              pkEvidencia: 1,
              evidencia:
                evidenciaServ.muestra_1.fileList[0].originFileObj.fullBase64Img.split(',')[1]
            };
            visitas[0].servidoresEvento[i].evidencias.push(newEvidencia);
          }
        }
        // se verifican cambios en la evidencia 2
        if (
          evidenciaServ.muestra_2?.file &&
          initialVisitas.servidoresEvento[i].evidencias[1] !== undefined
        ) {
          initialVisitas.servidoresEvento[i].evidencias[1].estatus = 0;
          visitas[0].servidoresEvento[i].evidencias.push(
            initialVisitas.servidoresEvento[i].evidencias[1]
          );
          if (evidenciaServ.muestra_2?.file?.status !== 'removed') {
            const newEvidencia = {
              pkEvidencia: 2,
              evidencia:
                evidenciaServ.muestra_2.fileList[0].originFileObj.fullBase64Img.split(',')[1]
            };
            visitas[0].servidoresEvento[i].evidencias.push(newEvidencia);
          }
        }
        // se verifican cambios en la evidencia 3
        if (
          evidenciaServ.muestra_3?.file &&
          initialVisitas.servidoresEvento[i].evidencias[2] !== undefined
        ) {
          initialVisitas.servidoresEvento[i].evidencias[2].estatus = 0;
          visitas[0].servidoresEvento[i].evidencias.push(
            initialVisitas.servidoresEvento[i].evidencias[2]
          );
          if (evidenciaServ.muestra_3?.file?.status !== 'removed') {
            const newEvidencia = {
              pkEvidencia: 3,
              evidencia:
                evidenciaServ.muestra_3.fileList[0].originFileObj.fullBase64Img.split(',')[1]
            };
            visitas[0].servidoresEvento[i].evidencias.push(newEvidencia);
          }
        }
        // se verifican cambios en la evidencia 4
        if (
          evidenciaServ.muestra_4?.file &&
          initialVisitas.servidoresEvento[i].evidencias[3] !== undefined
        ) {
          initialVisitas.servidoresEvento[i].evidencias[3].estatus = 0;
          visitas[0].servidoresEvento[i].evidencias.push(
            initialVisitas.servidoresEvento[i].evidencias[3]
          );
          if (evidenciaServ.muestra_4?.file?.status !== 'removed') {
            const newEvidencia = {
              pkEvidencia: 4,
              evidencia:
                evidenciaServ.muestra_4.fileList[0].originFileObj.fullBase64Img.split(',')[1]
            };
            visitas[0].servidoresEvento[i].evidencias.push(newEvidencia);
          }
        }
        // se verifican cambios en la evidencia 5
        if (
          evidenciaServ.muestra_5?.file &&
          initialVisitas.servidoresEvento[i].evidencias[4] !== undefined
        ) {
          initialVisitas.servidoresEvento[i].evidencias[4].estatus = 0;
          visitas[0].servidoresEvento[i].evidencias.push(
            initialVisitas.servidoresEvento[i].evidencias[4]
          );
          if (evidenciaServ.muestra_5?.file?.status !== 'removed') {
            const newEvidencia = {
              pkEvidencia: 5,
              evidencia:
                evidenciaServ.muestra_5.fileList[0].originFileObj.fullBase64Img.split(',')[1]
            };
            visitas[0].servidoresEvento[i].evidencias.push(newEvidencia);
          }
        }
      }
    }
  }
  // Verifica si se cambió el estatus. Si es cancelado se envía a cancelar el monitoreo
  if (dataFormulario?.estatus !== initialHallazgos[0]?.estatus && dataFormulario?.estatus === 3) {
    payloadBase.monitoreos.toCancel = [
      {
        pkMonitoreo: initialHallazgos?.[0]?.idMonitoreo,
        idMonitoreo: initialHallazgos?.[0]?.idMonitoreo,
        motivoCancelacion: dataFormulario?.motivoCancelacion
      }
    ];
  }

  payloadBase.hallazgos.toUpdate = hallazgos;
  payloadBase.visitas.toUpdate = visitas;
  return payloadBase;
};

export const formatFromBackToForm = (monitoreo) => {
  return {
    idProcesoGral: monitoreo.idProcesoGral,
    // estatus: monitoreo.hallazgos?.[0]?.estatus,
    estatus:
      monitoreo.hallazgos.length === 0 ? monitoreo.estatus : monitoreo.hallazgos?.[0]?.estatus,
    // motivoCancelacion: monitoreo.hallazgos?.[0]?.motivoCancelacion,
    motivoCancelacion:
      monitoreo.hallazgos.length === 0
        ? monitoreo.motivoCancelacion
        : monitoreo.hallazgos?.[0]?.motivoCancelacion,
    // Datos generales
    idEstado: monitoreo.idEstado,
    idProcesoEspecifico: monitoreo.hallazgos?.[0]?.idProcesoEspecifico,
    idAmbito: monitoreo.hallazgos?.[0]?.idAmbito,
    idDistritoLoc: monitoreo.hallazgos?.[0]?.idDistritoLoc,
    idDistritoFed: monitoreo.hallazgos?.[0]?.idDistritoFed,
    idEventoSIF: monitoreo.visitas[0]?.idEventoSIF,
    // estatusMonitoreo: monitoreo.estatusMonitoreo,  // ya no se requiere en Datos generales 30/04/2024
    acuerdoCOF: monitoreo.visitas[0]?.acuerdoCOF,
    fechaAcuerdoAprobado:
      monitoreo.visitas[0] && monitoreo.visitas[0]?.fechaAcuerdoAprobado !== ''
        ? dayjs(monitoreo.visitas[0]?.fechaAcuerdoAprobado, DATE_STRING_TO_MOMENT)
        : null,
    tipo_beneficio: monitoreo.hallazgos?.[0]?.tipoBeneficio,
    // Verificador
    verificadores:
      monitoreo.visitas[0]?.verificadores?.map((verificador) => ({
        nombre: verificador.nombre,
        apPaterno: verificador.apPaterno,
        catVerificador: verificador.idUsuario,
        apMaterno: verificador.apMaterno,
        puesto: verificador.puesto,
        idFirmante: verificador.idFirmante,
        oficioComision: verificador.oficioComision,
        fechaInicioComision: dayjs(verificador.fechaInicioComision, DATE_STRING_TO_MOMENT).locale(
          'es'
        ),
        fechaFinComision: dayjs(verificador.fechaFinComision, DATE_STRING_TO_MOMENT).locale('es')
      })) || [],
    // Datos de inicio de visita
    ordenVisita: monitoreo.visitas[0]?.ordenVisita,
    fechaApertura:
      monitoreo.visitas[0] && monitoreo.visitas[0]?.fechaApertura !== ''
        ? dayjs(monitoreo.visitas[0]?.fechaApertura, DATE_STRING_TO_MOMENT).locale('es')
        : null,
    horaApertura:
      monitoreo.visitas[0] && monitoreo.visitas[0]?.fechaApertura !== ''
        ? dayjs(monitoreo.visitas[0]?.fechaApertura, DATE_STRING_TO_MOMENT).locale('es')
        : null,
    fechaCierre:
      monitoreo.visitas[0] && monitoreo.visitas[0]?.fechaCierre !== ''
        ? dayjs(monitoreo.visitas[0]?.fechaCierre, DATE_STRING_TO_MOMENT).locale('es')
        : null,
    horaCierre:
      monitoreo.visitas[0] && monitoreo.visitas[0]?.fechaCierre !== ''
        ? dayjs(monitoreo.visitas[0]?.fechaCierre, DATE_STRING_TO_MOMENT).locale('es')
        : null,
    // Ubicación de la visita
    idMunicipio: monitoreo.visitas[0]?.ubicacion?.idMunicipio,
    calle: monitoreo.visitas[0]?.ubicacion?.calle,
    numero: monitoreo.visitas[0]?.ubicacion?.numero,
    colonia: monitoreo.visitas[0]?.ubicacion?.colonia,
    codigoPostal: monitoreo.visitas[0]?.ubicacion?.codigoPostal,
    entreCalle1: monitoreo.visitas[0]?.ubicacion?.entreCalle1,
    entreCalle2: monitoreo.visitas[0]?.ubicacion?.entreCalle2,
    referencias: monitoreo.visitas[0]?.ubicacion?.referencias,
    longitud: monitoreo.visitas[0]?.ubicacion?.longitud,
    latitud: monitoreo.visitas[0]?.ubicacion?.latitud,
    // Beneficiados
    beneficiados: [],
    // Datos del compareciente
    comparecientes:
      monitoreo.visitas[0]?.comparecientes?.map((compareciente) => ({
        nombre: compareciente.nombre,
        apPaterno: compareciente.apPaterno,
        apMaterno: compareciente.apMaterno,
        idTipoAsociacion: compareciente.idTipoAsociacion,
        idSujetoObligado: compareciente.idSujetoObligado,
        puesto: compareciente?.puesto,
        estadoCivil: compareciente?.estadoCivil,
        edad: compareciente?.edad,
        domicilio: compareciente?.domicilio,
        ocupacion: compareciente?.ocupacion,
        identificacion: compareciente?.identificacion,
        folioIdentificacion: compareciente?.folioIdentificacion,
        expedidaPor: compareciente?.expedidaPor,
        idFirmante: compareciente?.idFirmante,
        estatus: compareciente?.estatus // MNI - Se agrega envío de estatus para su futura actualización
      })) || [],
    // Hallazgos
    hallazgos:
      monitoreo.hallazgos?.map((hallazgo) => ({
        idEstado: monitoreo.idEstado,
        tipoHallazgo: hallazgo.idTipoHallazgo,
        isIdINE: hallazgo?.idINE ? 1 : 0,
        idINE: hallazgo?.idINE,
        cantidad: hallazgo?.cantidad,
        subTipoHallazgo: hallazgo?.subTipoHallazgo,
        idTipoMedida: hallazgo?.idTipoMedida,
        tipoMedida: hallazgo?.tipoMedida,
        medida: hallazgo?.medida,
        tamanio: hallazgo?.tamanio,
        color: hallazgo?.color,
        lema: hallazgo?.lema,
        placas: hallazgo?.placas,
        duracionHr: hallazgo?.duracionHr,
        duracionMin: hallazgo?.duracionMin,
        duracionSeg: hallazgo?.duracionSeg,
        infAdicional: hallazgo?.infAdicional
        // TODO: integrar imagenes
      })) || [],
    // Servidores Públicos
    servidores:
      monitoreo.visitas[0]?.servidoresEvento?.map((servidor) => ({
        nombre: servidor.nombre,
        apPaterno: servidor.apPaterno,
        apMaterno: servidor?.apMaterno,
        puesto: servidor?.puesto,
        claveElector: servidor?.claveElector,
        dependencia: servidor?.dependencia,
        horarioHr: servidor?.horarioHr,
        horarioMin: servidor?.horarioMin,
        horarioSeg: servidor?.horarioSeg,
        nivelParticipacion: servidor?.nivelParticipacion,
        transporte: servidor?.transporte,
        idFirmante: servidor?.idFirmante
      })) || [],
    // Testigos
    testigos:
      monitoreo.visitas[0]?.testigos?.map((testigo) => ({
        nombre: testigo.nombre,
        apPaterno: testigo.apPaterno,
        apMaterno: testigo?.apMaterno,
        identificacion: testigo.identificacion,
        folioIdentificacion: testigo.folioIdentificacion,
        expedidaPor: testigo?.expedidaPor,
        edad: testigo?.edad,
        domicilio: testigo?.domicilio,
        institucion: testigo?.institucion,
        cargo: testigo?.cargo,
        idFirmante: testigo?.idFirmante,
        estatus: testigo?.estatus // MNI - Se agrega envío de estatus para su futura actualización
      })) || [],

    // Complemento de la visita
    duracionHr: monitoreo.visitas[0]?.duracionHr,
    duracionMin: monitoreo.visitas[0]?.duracionMin,
    duracionSeg: monitoreo.visitas[0]?.duracionSeg,
    manifestacion: monitoreo.visitas[0]?.manifestacion,
    otrosHechos: monitoreo.visitas[0]?.otrosHechos,
    identificadorEvento: monitoreo.visitas[0]?.identificadorEvento,
    infAdicional: monitoreo.visitas[0]?.infAdicional,

    // Contestacion del SO
    idTipoAsociacion: monitoreo.visitas[0]?.idTipoAsociacion,
    idSujetoObligado: monitoreo.visitas[0]?.idSujetoObligado,
    numeroEscrito: monitoreo.visitas[0]?.numeroEscrito,
    nombreFirmante: monitoreo.visitas[0]?.nombreFirmante,
    fechaEscrito:
      monitoreo.visitas[0] && monitoreo.visitas[0]?.fechaEscrito !== ''
        ? dayjs(monitoreo.visitas[0]?.fechaEscrito, DATE_STRING_TO_MOMENT).locale('es')
        : null,
    puesto: monitoreo.visitas[0]?.puesto,

    // Designado por el SO
    designados:
      monitoreo.visitas[0]?.designados_so?.map((designado) => ({
        idTipoAsociacion: designado?.idTipoAsociacion,
        idSujetoObligado: designado?.idSujetoObligado,
        numeroEscrito: designado?.numeroEscrito,
        nombre: designado?.nombre,
        puesto: designado?.puesto
      })) || [],

    // Documentación Recibida
    documentaciones:
      monitoreo.visitas[0]?.documentaciones
        ?.filter((documentacion) => documentacion.estatus !== 0)
        ?.map((documentacion) => ({
          cantidad: documentacion?.cantidad,
          idDocumentacion: documentacion?.idDocumentacion,
          idVisita: documentacion?.idVisita,
          observaciones: documentacion?.observaciones,
          tipoDocumento: documentacion?.tipoDocumento
        })) || []
  };
};
